import { useState } from 'react';

import { ChevronRight } from '@gympass/yoga-icons';

import ChatTextBox from 'components/ChatTextBox';
import FileUploader from 'components/FileUploader';

import { ChatFooterProps } from './types';

import * as S from './styles';

// The fileInput feature is out of scope for now so it is a draft and will not be delivered
const SHOW_FILE_INPUT = false;

const ChatFooter: React.FC<ChatFooterProps> = ({
  identity,
  messageHandler,
  selectedConversation,
  ...props
}) => {
  const [messageToSend, setMessageToSend] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target?.value;

    setMessageToSend(val);
  };

  const handleSubmit = async () => {
    if (selectedConversation && messageToSend && messageHandler) {
      await messageHandler.sendMessage(
        messageToSend,
        selectedConversation,
        identity,
      );
      setMessageToSend('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const keyCode = e.which || e.key;

    if (keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    } else {
      selectedConversation?.typing();
    }
  };

  const handleFile = (/* file: File */) => {
    // console.log(file);
  };

  return (
    <S.ChatFooterRoot {...props} onKeyDown={handleKeyDown}>
      {SHOW_FILE_INPUT && <FileUploader onFileUpload={handleFile} />}
      <ChatTextBox value={messageToSend} onChange={handleChange} />
      <S.SendButton
        data-testid="chatFooterSendButton"
        icon={ChevronRight}
        onClick={handleSubmit}
      />
    </S.ChatFooterRoot>
  );
};

export default ChatFooter;
